import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        height: 'calc(100% - 40px)', 
        overflowY: 'scroll', 
        color: '#fff', 
        paddingTop: 0,
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    color: {
        color: '#fff',
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));

const getRows = (cashiers) => {
    return cashiers.data.map((item, key) => {
        return {
            id: item.id,
            login: item.login,
            end_balance: item.end_balance,
            status: item.status ? 'Открыта' : 'Закрыта',
            groups: item.groups ? item.groups : '-'
        }
    })
}


const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'end_balance', label: 'Баланс'},
    { id: 'status', label: 'Смена'},
    { id: 'groups', label: 'Группа'}
];

export {
    useStyles,
    columns,
    getRows
}